import { render, staticRenderFns } from "./MsgManager.vue?vue&type=template&id=360c4ec3&"
import script from "./MsgManager.vue?vue&type=script&lang=js&"
export * from "./MsgManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports